import { EndpointSetting } from "@/constants/app/type"
import { normalizeVouchersGetAllResponse } from "@/utils/voucher/normalizeVoucherCategories"
import { getVoucherMarketKeyFromBody } from "@/utils/voucher/getVoucherMarketKey"
import { getCachedSystemTieredDiscount } from "@/utils/voucher/fetchVouchersAll"

export const callbackVoucherGetAll: EndpointSetting["caller"] = (state, action) => {
  state.voucher_get_all.data = normalizeVouchersGetAllResponse(action.payload)
  // DOP-942: `callerService` trả về Voucher[] (đã mất categories) → đọc cấu hình trừ dần từ cache
  // thô theo body. Chỉ ghi đè khi thực sự parse được cấu hình để không xoá cấu hình do SSR nạp trước
  // (VouchersContainer → setPublicVouchers) trong trường hợp thunk chạy nhờ cache-hit (không parse lại).
  const tiered = getCachedSystemTieredDiscount(action.meta?.arg?.body)
  if (Object.keys(tiered.systems).length) {
    state.voucher_get_all.systemTieredDiscount = tiered
  }
  state.voucher_get_all.fetchedMarketKey = getVoucherMarketKeyFromBody(
    action.meta?.arg?.body,
  )
}
